/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import * as colors from '../colors';
import { qtmBlack, QtmPalette, qtmWhite, setGreyAliases } from './Palette';

/** Palette of colors for light theme */
export const qtmLightThemePalette: QtmPalette = {
  // Primary colors
  blue: colors.blue[700],
  darkBlue: colors.blue[900],
  lightBlue: colors.blue[300],
  lightestBlue: colors.blue[50],

  // Grays
  darkestGray: colors.gray[800],
  darkGray: colors.gray[700],
  gray: colors.gray[500],
  lightGray: colors.gray[300],
  lightestGray: colors.gray[100],

  // Supporting colors
  blueGray: colors.blue.A200,
  darkRed: colors.red[900],
  red: colors.red[700],
  lightRed: colors.red[200],
  lightestRed: colors.red[50],
  darkGreen: colors.green[900],
  green: colors.green[700],
  lightGreen: colors.green[100],
  yellow: colors.yellow[600],
  lightYellow: colors.yellow[100],
  orange: colors.orange[700],
  purple: colors.purple[400],

  contrast: {
    // Primary colors
    blue: qtmWhite,
    darkBlue: qtmWhite,
    lightBlue: qtmBlack,
    lightestBlue: qtmBlack,

    // Grays
    darkestGray: qtmWhite,
    darkGray: qtmWhite,
    gray: qtmBlack,
    lightGray: qtmBlack,
    lightestGray: qtmBlack,

    // Supporting colors
    blueGray: qtmBlack,
    darkRed: qtmWhite,
    red: qtmWhite,
    lightRed: qtmBlack,
    lightestRed: qtmBlack,
    darkGreen: qtmWhite,
    green: qtmBlack,
    lightGreen: qtmBlack,
    yellow: qtmBlack,
    lightYellow: qtmBlack,
    orange: qtmBlack,
    purple: qtmWhite,
  },
};

setGreyAliases(qtmLightThemePalette);
